import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-root',
    styleUrls: ['./app.component.scss'],
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  constructor() { }

  public ngOnInit(): void {
    // Force https in production to prevent CORS error.
    if (environment.production && location.protocol === 'http:') {
      window.location.href = window.location.href.replace('http', 'https');
    }
  }
}
